module.exports = __webpack_public_path__ + "img/promo-icon.d4565eb9.svg";